<div style="position: fixed; top:0; z-index: 1000; left:0; height:100%; width:100%; background: #222c;">
</div>


<div class="sideBar-info">
  <!-- <ion-card> -->

  <div style="overflow-x: auto; height:calc(100vh - 150px)">
    <ion-icon color='danger' name="close-circle" style="position: fixed; right:20px; top:10px; z-index: 99;"
      class='font2 floatingCloseAttachment cursorpoint' (click)='closePopup.emit()'></ion-icon>
    <div class="font1_2">
      <app-pd-card [emp]="emp" [showCreator]="true"></app-pd-card>

      <ion-row class="textCenter ">
        <!-- Merge -->
        <ion-col size="3" class="fab-container"
          *ngIf="(emp && emp?.creator_can_edit && emp?.created_by == this.auth?.loggedInEmployee?.id) || emp?.id == this.auth?.loggedInEmployee?.id">
          <ion-fab-button size="small" (click)="clickMerge()">
            <ion-icon name="git-network"></ion-icon>
          </ion-fab-button>
          <div class="fab-label">{{'Merge' |translate}}</div>
        </ion-col>

        <!-- Share / Active -->
        <ion-col size="3" class="fab-container">
          <ng-container *ngIf="emp.user.user_pd.status != 'Verified' || !emp.user.user_pd.email">
            <ion-fab-button size="small" (click)="inviteService.createInvite(null, emp)">
              <ion-icon name="share-social"></ion-icon>
            </ion-fab-button>
            <div class="fab-label">{{'Invite' |translate}}</div>
          </ng-container>

          <ng-container *ngIf="emp.user.user_pd.status == 'Verified'">
            <ion-fab-button size="small" color="success">
              <ion-icon name="checkmark-done-outline"></ion-icon>
            </ion-fab-button>
            <div class="fab-label">{{'Active' |translate}}</div>
          </ng-container>
        </ion-col>

        <!-- Edit -->
        <ion-col size="3" class="fab-container"
          *ngIf="(emp.creator_can_edit && emp.created_by == this.auth?.loggedInEmployee?.id) || emp.id == this.auth?.loggedInEmployee?.id">
          <ion-fab-button size="small" (click)="clickEdit()">
            <ion-icon name="pencil"></ion-icon>
          </ion-fab-button>
          <div class="fab-label">{{'Edit' |translate}}</div>
        </ion-col>

        <!-- Delete -->
        <ion-col size="3" class="fab-container"
          *ngIf="(emp.creator_can_edit && emp.created_by == this.auth?.loggedInEmployee?.id)">
          <ion-fab-button size="small" (click)="clickDelete()">
            <ion-icon name="trash"></ion-icon>
          </ion-fab-button>
          <div class="fab-label">{{'Delete' |translate}}</div>
        </ion-col>
      </ion-row>

    </div>
  </div>
  <!-- </ion-card> -->

</div>